import { render, staticRenderFns } from "./auth-promo-panel.vue?vue&type=template&id=50e5ae2e&scoped=true&"
import script from "./auth-promo-panel.vue?vue&type=script&lang=js&"
export * from "./auth-promo-panel.vue?vue&type=script&lang=js&"
import style0 from "./auth-promo-panel.vue?vue&type=style&index=0&id=50e5ae2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e5ae2e",
  null
  
)

export default component.exports